// extracted by mini-css-extract-plugin
export default {"breadcrumbItem":"r3WBM","breadcrumbLink":"pfDNZ"};